import React, { useState, useEffect } from "react";
import { Link, graphql } from "gatsby";
import { makeStyles } from "@material-ui/styles";
import Chip from "@material-ui/core/Chip";
import ButtonBase from "@material-ui/core/ButtonBase";
import PreviousIcon from "@material-ui/icons/ChevronLeft";
import NextIcon from "@material-ui/icons/ChevronRight";
import AppLayout from "../components/Styles/AppLayout";
import PageLayout from "../components/Styles/PageLayout";
import Toc from "../components/toc";
import Nav from "../components/guideNav";

const useStyles = makeStyles(theme => ({
  content: {
    "& a": { color: theme.palette.text.primary }
  },
  bottomNavigation: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    alignItems: "center",
    height: "50px"
  },
  next: {
    display: "flex",
    justifyContent: "flex-end"
  },
  icon: {
    width: "32px",
    height: "32px"
  }
}));

const GuideDoc = props => {
  const [activeHash, setActiveHash] = useState();
  const classes = useStyles();
  const { title, index, tags, content } = props.data.contentfulGuide;
  const { next, previous } = props.pageContext;
  useEffect(() => {
    const anchors = document.querySelectorAll(".anchor");
    const options = {
      rootMargin: "0px 0px -85% 0px"
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveHash(entry.target.getAttribute("href"));
        }
      });
    }, options);
    anchors.forEach(anchor => observer.observe(anchor));
  }, []);
  return (
    <AppLayout location={props.location}>
      <PageLayout>
        <Nav location={props.location} />
        <div className="doc__outer-container doc-content">
          <div>
            <h1 title={`${title} - ${index}`}>{title}</h1>
            <div className="tag-container">
              {tags &&
                tags.map((tag, i) => {
                  return (
                    <Chip
                      key={i}
                      label={tag}
                      variant="outlined"
                      className="tag"
                    />
                  );
                })}
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html: content.childMarkdownRemark.html
              }}
              className={classes.content}
            />
          </div>
          <div className={classes.bottomNavigation}>
            <div className={classes.previous}>
              {previous && (
                <ButtonBase component={Link} to={`/guide/${previous.slug}/`}>
                  <PreviousIcon className={classes.icon} />
                </ButtonBase>
              )}
            </div>
            <div className={classes.next}>
              {next && (
                <ButtonBase component={Link} to={`/guide/${next.slug}/`}>
                  <NextIcon className={classes.icon} />
                </ButtonBase>
              )}
            </div>
          </div>
        </div>
        <Toc
          toc={content.childMarkdownRemark.tableOfContents}
          activeHash={activeHash}
        />
      </PageLayout>
    </AppLayout>
  );
};

export const pageQuery = graphql`
  query GuideDocQuery($slug: String!) {
    contentfulGuide(slug: { eq: $slug }) {
      title
      index
      tags
      content {
        childMarkdownRemark {
          html
          tableOfContents(
            absolute: false
            heading: ""
            maxDepth: 4
            pathToSlugField: ""
          )
        }
      }
    }
  }
`;

export default GuideDoc;
